import { createContext } from "react"

// when you update this file, be sure to update the query in App.tsx as well!!
type Tutor = {
  id: string
  fullName: string
  firstName: string
  lastName: string
  email: string
  ssoEmail: string
  createdAt: Date
  calendarId: string
  mayCreateExpense: boolean
  billDotComVendorId: string
  canSubmitGeneralExpenses: boolean
  hasSubmittedFingerprintExpense: boolean
  hasSubmittedIntroSessionExpense: boolean
  hasUnbilledSessions: boolean
  messagingDisabled: boolean
  avatar: {
    thumbUrl: string
  }
}

type TutorContext = {
  viewer?: Tutor
  unreadMessageCount?: number
}

export default createContext<TutorContext>({})
